import { TextField as MuiTextField, type TextFieldProps } from "@mui/material";
import { forwardRef } from "react";

import { characterLimitHelperText, readMaxLength } from "./characterLimitHelperText";

export const CharacterLimitedTextField = forwardRef<HTMLDivElement, TextFieldProps>(
  function CharacterLimitedTextField({ helperText, inputProps, value, ...props }, ref) {
    return (
      <MuiTextField
        {...props}
        helperText={characterLimitHelperText({
          helperText,
          maxLength: readMaxLength(inputProps),
          value,
        })}
        inputProps={inputProps}
        ref={ref}
        value={value}
      />
    );
  },
);
